module.exports = __webpack_public_path__ + "img/hakone_kaizokusen.8592fa92.jpg";